/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_BenchmarkInputs */

const en_directory_agent_readiness_benchmark = /** @type {(inputs: Directory_Agent_Readiness_BenchmarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benchmark`)
};

const zh_directory_agent_readiness_benchmark = /** @type {(inputs: Directory_Agent_Readiness_BenchmarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`评测基准`)
};

/**
* | output |
* | --- |
* | "Benchmark" |
*
* @param {Directory_Agent_Readiness_BenchmarkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_benchmark = /** @type {((inputs?: Directory_Agent_Readiness_BenchmarkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_BenchmarkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_benchmark(inputs)
	return zh_directory_agent_readiness_benchmark(inputs)
});
export { directory_agent_readiness_benchmark as "directory.agent_readiness.benchmark" }